import React from 'react';
import Skeleton from '../index';
export default ({ count, type }) => {
    const skeletons = [];
    for (let index = 0; index < count; index++) {
        skeletons.push(React.createElement(Skeleton, { key: "skelton-" + index, type: type }));
    }
    return (React.createElement("div", { "data-type": type }, skeletons));
};
